.media-minimal-skin {
  media-error-dialog {
    position: absolute;
    inset: 0;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;

    &:not([data-open]) {
      display: none;
    }
  }

  .media-dialog__backdrop {
    position: absolute;
    inset: 0;
    z-index: 10;
    pointer-events: none;
    background: oklch(0 0 0 / 0.2);
    backdrop-filter: blur(16px) saturate(1.2);
    opacity: 1;
    transition-timing-function: var(--media-dialog-transition-timing-function);
    transition-duration: var(--media-dialog-transition-duration);
    transition-property: opacity;
    transition-delay: var(--media-dialog-transition-delay);

    &[data-starting-style],
    &[data-ending-style] {
      opacity: 0;
    }

    &[data-ending-style] {
      transition-delay: 0ms;
    }

    &:not([data-open]) {
      display: none;
    }
  }

  .media-dialog__popup {
    outline: none;
  }

  .media-dialog__title {
    font-weight: 600;
    line-height: 1.25;
  }

  .media-dialog__description {
    overflow-wrap: anywhere;
    opacity: 0.7;
  }

  .media-dialog__actions {
    display: flex;
    gap: calc(var(--media-spacing) * 2);

    > * {
      flex: 1;
    }
  }
}
